import { atom } from 'recoil';

export const aMemoComposerUserIds = atom<string[]>({ key: 'aMemoComposerUserIds', default: [] });
export const aDirectMemoComposerUserIds = atom<string[]>({ key: 'aDirectMemoComposerUserIds', default: [] });
